import { render, staticRenderFns } from "./UseItem.vue?vue&type=template&id=81e37118&scoped=true&"
import script from "./UseItem.vue?vue&type=script&lang=js&"
export * from "./UseItem.vue?vue&type=script&lang=js&"
import style0 from "../../../less/gift.less?vue&type=style&index=0&id=81e37118&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e37118",
  null
  
)

export default component.exports